import React from 'react';
import Reflux from 'reflux';
import * as Utilities from '../Utilities';
import NotificationsActions from '../actions/NotificationsActions';
import history from '../history';
import {Link} from 'react-router-dom';
import './CommentNotification.css';

class CommentNotification extends Reflux.Component {
    goToNotif = (notif) => {
        history.push('/topic/' + Utilities.getHumanUrl(notif.relatedTop));
        NotificationsActions.markAsReaded(notif._id);
    }
    render () {
        let notif = this.props.notification;
        return (
          <li className={!notif.readed ? 'unread' : ''}>
            <div className='content-image'>
              <object type='image/jpg' data={notif.from.profile_image.sizeSmall} >
                <img src='/images/icons/default-big.jpg' />
              </object>
            </div>
            <div className='txt-notif'>
              <p>
                <Link className='truncate' to={'/p/' + notif.from.username}><span>{notif.from.name}</span></Link> ha comentado tu top5{notif.relatedTop ? <a className='comment-link-top' onClick={() => { this.goToNotif(notif); }}><p> {notif.relatedTop.title} </p></a> : '.'}
              </p>
              <span><img src='/images/icons/comment-notif.svg' />{ Utilities.getHumanTime(notif.createdAt)}</span>
            </div>
          </li>
        );
    };
}

export default CommentNotification;



// WEBPACK FOOTER //
// ./src/components/CommentNotification.js